import React from 'react';

export const ThumbsDownIcon = ({ 
  size = 20, 
  color = 'currentColor', 
  strokeWidth = 1.5,
  className = ''
}) => {
  const thumbStroke = strokeWidth * 2;

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 40 40" 
      fill="none"
      className={className}
    >
      <path
        d="M37 18.4C37 20.3883 35.3882 22 33.4 22C30.4177 22 28 19.5824 28 16.6V9.4C28 6.41758 30.4177 4 33.4 4C35.3882 4 37 5.61172 37 7.6V18.4Z"
        stroke={color}
        strokeWidth={thumbStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8688 27.8941L14.3127 26.2751C14.6763 24.9485 14.8582 24.2852 14.7183 23.7613C14.6052 23.3376 14.3568 22.9722 14.0183 22.7319C13.6 22.4348 12.9672 22.4348 11.7015 22.4348H11.0282C6.74468 22.4348 4.60301 22.4348 3.59134 21.0027C3.47584 20.8392 3.37301 20.665 3.28401 20.4824C2.50584 18.8855 3.39051 16.7339 5.16001 12.4309C6.78384 8.48207 7.59584 6.50767 9.10334 5.34551C9.24918 5.23313 9.39917 5.12697 9.55284 5.02758C11.14 4 13.1063 4 17.0393 4H17.8923C22.6572 4 25.0395 4 26.5198 5.61976C28 7.23972 28 9.84677 28 15.0609V16.8936C28 19.6337 28 21.0037 27.5694 22.2577C27.1389 23.5117 26.3144 24.5428 24.6655 26.6049L17.8465 35.1331C17.6755 35.3469 17.59 35.4539 17.5145 35.528C16.8108 36.2197 15.7247 36.1419 15.1093 35.3556C15.0433 35.2713 14.9713 35.1531 14.8273 34.9166C14.602 34.5467 14.4893 34.3618 14.391 34.1785C13.512 32.5381 13.246 30.5894 13.6487 28.7395C13.6937 28.5329 13.752 28.3198 13.8688 27.8941Z"
        stroke={color}
        strokeWidth={thumbStroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
